import React, { useContext, useState } from 'react';
import '../../styles/App.scss';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import useEmailValidation from '../hooks/useEmailValidation';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import eyeImg from '../../images/eye.svg'
import eyeClosed from '../../images/eye_closed.svg'
import WhmcsApi from '../../services/WhmcsApi'
import CircularProgress from '@mui/material/CircularProgress';
import { AuthContext } from '../../Auth';
import Modal from '@mui/material/Modal';
import RecoverPassword from './RecoverPassword';
import SendEmail from './SendEmail';
import TwoFAModal from './TwoFAModal';
import { useTranslation } from 'react-i18next';
import Cookies from 'universal-cookie';

export default function SignIn({ setValue, onOpenRegister, source, onCloseLogin, onCloseRegister, showSectionRegister = true }) {
    const { setUserAuth } = useContext(AuthContext);

    const { email, emailError, handleEmailChange } = useEmailValidation();
    const [showPassword, setShowPassword] = React.useState(false);
    const [loading, setLoading] = useState(false);
    const [remember, setRemember] = useState(false);

    const [open2FA, setOpen2FA] = useState({open: false, userId:null});
    const [open, setOpen] = React.useState(false);
    const [sendMail, setSendMail] = React.useState(false);
    const [tempAuthResponse, setTempAuthResponse] = useState(null);
    const { t } = useTranslation();

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const handleOpen2FA = (userId) => setOpen2FA({ open: true, userId });
    const handleClose2FA = (userId = null) => setOpen2FA({ open: false, userId });

    const handleClickShowPassword = () => setShowPassword((show) => !show);
    const handleMouseDownPassword = (event) => {
        event.preventDefault();
      };

    const handleClick = (event) => {
        event.preventDefault();
        setValue(1)
    };

    const handleCheckboxChange = (event) => {
        setRemember(event.target.checked);
      };

    const handleSubmit = (event) => {
        event.preventDefault();
        setLoading(true);
        const data = new FormData(event.currentTarget);
        let email = data.get('email')
        let password = data.get('password');
        const Swal = require('sweetalert2')

        if(email == "" || password == ""){
            Swal.fire({ title: 'Error!', text: t("login.errors.emptyTexts"), 
            icon: 'error', confirmButtonText: 'OK'
              })
              setLoading(false);
              return 0;
        }
    
        const fetchLogin = async () => {
            try {
              const whmcsApi = new WhmcsApi(); // Crear instancia de WhmcsApi
              const response = await whmcsApi.request('login', {
                email: email,
                password: password,
                remember
              });
              if (response.result == 'error') {
                Swal.fire({
                    title: 'Error!',
                    text: response.message,
                    icon: 'error',
                    confirmButtonText: 'OK'
                  })
              } else {               
                    if (response.result == 'success') {
                    // si el usuario tiene activo la autenticacion de 2f se tiene que validar antes de completar el inicio de sesion
                    if (response.twoFactorEnabled) {
                        setTempAuthResponse(response); 
                        handleOpen2FA( response.userid );
                    } else {
                        //Guarda token y session
                        const cookieDomain = process.env.REACT_APP_COOKIE_DOMAIN;

                        const cookies = new Cookies(null, { path: '/', domain: cookieDomain});
                        // cookies.set('WHMCSUser', response.data.session);
                        // const cookieOptions = {
                        //     path: '/',
                        //     domain: cookieDomain,
                        //     secure: true, // Use secure cookies if the app is served over HTTPS
                        //     sameSite: 'None', // Or 'None' for cross-origin; must be 'None' if Secure is true
                        // };

                        cookies.set('WHMCSUser', response.data.session);
                        setUserAuth(response.data);

                        //Si se inicio sesion desde el modal se cierra aqui debo cerrar el modal se inicio de sesion
                        if(source == 'modal'){
                            onCloseLogin();
                        }
                    }
                }
              }
            } catch (error) {
                Swal.fire({
                    title: 'Error!',
                    text: error,
                    icon: 'error',
                    confirmButtonText: 'OK'
                  })
                setLoading(false);
              console.error('Failed to fetch login form:', error);
            } finally {
                setLoading(false);
            }
          };
      
          fetchLogin();
    };

    const handle2FA = (code=null) => {
        if(tempAuthResponse){
            setUserAuth(tempAuthResponse);
        }
        handleClose2FA(code);
    };
    return (
        <Container component="main">
            <CssBaseline />
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
            <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 3 }}>
            <Grid container >
                    <TextField
                        margin="normal"
                        fullWidth
                        id="email"
                        label={t("signUp.fields.email")}
                        name="email"
                        autoComplete="email"
                        autoFocus
                        value={email}
                        onChange={(e) => handleEmailChange(e.target.value)}
                        error={!!emailError}
                        helperText={emailError}
                    />            
                    <TextField
                        id="filled-adornment-password"
                        fullWidth
                        name="password"
                        label={t("signUp.fields.password")}
                        type={showPassword ? 'text' : 'password'}
                        autoComplete="new-password"
                        InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={handleClickShowPassword}
                                    onMouseDown={handleMouseDownPassword}
                                    edge="end"
                                    >
                                    {showPassword ?  
                                    <img src={eyeImg} alt="Mostrar password" height="24px" width="30px"></img> 
                                    :  
                                    <img src={eyeClosed} alt="Mostrar password" height="24px" width="30px"></img>
                                    }
                                </IconButton>
                            </InputAdornment>
                        ),
                        }}
                    />
                    <Grid container sx={{ justifyContent: {
                                        xs: 'center',   // Para pantallas pequeñas (móvil)
                                        sm: 'space-between',  // Para pantallas más grandes (tablet y más)
                                        }, }}>
                        <FormControlLabel
                            control={<Checkbox value="remember" sx={{ color: 'green' }} />}
                            label={t("login.rememberData")}
                            checked={remember}
                            onChange={handleCheckboxChange}
                            sx={{
                                '& .MuiFormControlLabel-label': {
                                    color: '#17181A',
                                    fontFamily: 'roboto',
                                    fontSize: '14px',
                                    fontWeight: '500',
                                    textAlign: 'center'
                                },
                               
                            }}
                        />
                        <Grid item  
                            sx={{
                            display: 'flex',
                            alignItems: 'center',
                         }}>
                            <Link onClick={handleOpen} style={{  fontFamily: 'roboto', fontSize: '14px', cursor: 'pointer', color:'#A0A8B5'}} variant="body2">
                                {t("login.forgetPass")}
                            </Link>
                        </Grid>
                    </Grid>

                    <Modal
                        open={open}
                        onClose={handleClose}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                    >
                    {sendMail 
                        ? <SendEmail setOpen={setOpen} setSendMail={setSendMail} /> 
                        : <RecoverPassword setOpen={setOpen} setSendMail={setSendMail} />}
                    </Modal>
                    </Grid>
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        sx={{ mt: 3, mb: 2, textTransform: 'none', fontFamily: 'Patua One, sans-serif', fontSize: '18px',borderRadius: '10px', height: '60px' }}
                        disabled={loading}
                        className="btn-green"
                    >
                        {loading ? <CircularProgress sx={{color: 'white'}} /> : t("login.btnText")}
                    </Button>

                   {showSectionRegister &&
                        <Grid container sx={{ justifyContent: 'center', alignItems: 'center', alignContent: 'center' }}>
                            <Grid item>
                                <div style={{ color: '#A0A8B5' }} className='roboto'>{t("login.stillAccount")}</div>

                            </Grid>
                            <Grid item>
                                {source != 'modal' &&
                                    <Link style={{ fontSize: '16px', cursor: 'pointer', marginLeft: 16 }} onClick={handleClick} variant="body2">
                                        {t("login.registerText")}
                                    </Link>
                                }
                                {source == 'modal' &&
                                    <Link style={{ fontSize: '16px', cursor: 'pointer', marginLeft: 16 }} onClick={onOpenRegister} onCloseRegister={onCloseRegister} variant="body2">
                                        {t("login.registerText")}
                                    </Link>
                                }
                            </Grid>
                        </Grid>
                    }
                </Box>
            </Box>
            <TwoFAModal open={open2FA.open} userId={open2FA.userId} handleClose={handleClose2FA} handleVerify={handle2FA} authResponse={tempAuthResponse}  />
        </Container>
    );
}
